import React from "react";
import { Modal } from "react-bootstrap";
import styles from "./ConfirmationPopup.module.css"; // Import your styles
import { Link } from "react-router-dom";

const ConfirmationPopup = ({
  title,
  message,
  onConfirm,
  onCancel,
  open,
  confirmLable,
}) => {
  return (
    <Modal show={open} onHide={onCancel} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="ModalHeader mb-0">{title}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div class="mb-4 col-md-10">
          <p className={` text-start`} style={{ minHeight: "100px" }}>
            {message}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end w-100">
          {/* <button
            className={`${styles.dont_delete} bg-white secondaryButton border-0 mx-2`}
            onClick={onCancel}
          >
            No, Keep It
          </button>
          <button className="primaryButton border-0 mx-2" onClick={onConfirm}>
            Yes, Remove
          </button> */}

          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                onClick={onCancel}
                to="javascript:void(0)"
                className="secondaryButton "
                variant="secondary"
              >
                No, Keep It
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={onConfirm}
                className="primaryButton"
                variant="primary"
              >
                {" "}
                {confirmLable ? confirmLable : "Yes, Remove"}
                {/* Yes, Remove */}
              </Link>
            </li>
          </ul>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationPopup;
